export const SKOOL_URL = "https://www.skool.com/chicadi-7006";

export const IMG = {
  heroDancers:
    "https://customer-assets-agu9un31.emergentagent.net/job_65c41d42-bbec-47c5-9539-54df8500ce69/artifacts/u2lti1qc_Black%20and%20White%20Modern%20Dance%20Presentation%20%281%29.png",
  chicaDance:
    "https://customer-assets-agu9un31.emergentagent.net/job_65c41d42-bbec-47c5-9539-54df8500ce69/artifacts/yh1gpqis_Black%20and%20White%20Modern%20Dance%20Presentation.png",
  kpopDancing:
    "https://customer-assets-agu9un31.emergentagent.net/job_65c41d42-bbec-47c5-9539-54df8500ce69/artifacts/zdkyg2n3_Black%20and%20White%20Modern%20Dance%20Presentation%20%282%29.png",
  founder:
    "https://customer-assets-jt897jd0.emergentagent.net/job_playful-skool-entry/artifacts/bpy2jjyu_photo_2026-08-14_09-29-25.jpg",
  studioFloor:
    "https://customer-assets-jt897jd0.emergentagent.net/job_playful-skool-entry/artifacts/pv74jmdv_image.png",
  greenScreen:
    "https://customer-assets-jt897jd0.emergentagent.net/job_playful-skool-entry/artifacts/p2l0la72_image.png",
  stageSet:
    "https://customer-assets-jt897jd0.emergentagent.net/job_playful-skool-entry/artifacts/9l9jjxlh_image.png",
  stepWarmup:
    "https://static.prod-images.emergentagent.com/jobs/65c41d42-bbec-47c5-9539-54df8500ce69/images/362cea6d40b24a371e3e5408f08a4e741adb45afe3f3eea1fe2952b517315d4b.jpeg",
  stepDrill:
    "https://static.prod-images.emergentagent.com/jobs/65c41d42-bbec-47c5-9539-54df8500ce69/images/2331a98f56f84f09c7d5eeeca396b0d88f22e27655bf3017a15f5e29b5e56ab9.jpeg",
  stepChoreo:
    "https://static.prod-images.emergentagent.com/jobs/65c41d42-bbec-47c5-9539-54df8500ce69/images/eb8040399c83f37532ed4102aba11ca7ee10b731a619ead5edb7551930263ae3.jpeg",
  stepPerformance:
    "https://static.prod-images.emergentagent.com/jobs/65c41d42-bbec-47c5-9539-54df8500ce69/images/32b75c43dcaa6cf93a96a2ef4e9aeaafc29a2c43ed3955fc1d8a875706ea6e9c.jpeg",
  worldMap: "https://customer-assets-jt897jd0.emergentagent.net/job_playful-skool-entry/artifacts/d0op09y9_image.png",
  finalCtaTraining:
    "https://static.prod-images.emergentagent.com/jobs/65c41d42-bbec-47c5-9539-54df8500ce69/images/f613b6043d55e46076832103d1ae8705cf2e5f1dac86d17b8eb09ff24a61971d.jpeg",
};

export const INSTAGRAM_URL = "https://www.instagram.com/adina.joline/?hl=en";

export const INTRO_VIDEO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_playful-skool-entry/artifacts/5xchlqr2_HOW%20TO%20TRAIN%20LIKE%20A%20K-POP%20TRAINEE%20FROM%20HOME%21.mp4";
